// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatapointsComparisonExcelRequestAllOfFromJSON, DatapointsComparisonExcelRequestAllOfToJSON, DatapointsComparisonSpecificsFromJSON, DatapointsComparisonSpecificsToJSON, DatapointsRequestBaseFromJSON, DatapointsRequestBaseToJSON, DatapointsRequestOptionsFromJSON, DatapointsRequestOptionsToJSON, } from './';
export function DatapointsComparisonExcelRequestFromJSON(json) {
    return {
        ...DatapointsComparisonExcelRequestAllOfFromJSON(json),
        ...DatapointsComparisonSpecificsFromJSON(json),
        ...DatapointsRequestBaseFromJSON(json),
        ...DatapointsRequestOptionsFromJSON(json),
    };
}
export function DatapointsComparisonExcelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        ...DatapointsComparisonExcelRequestAllOfToJSON(value),
        ...DatapointsComparisonSpecificsToJSON(value),
        ...DatapointsRequestBaseToJSON(value),
        ...DatapointsRequestOptionsToJSON(value),
    };
}
